import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { clsx } from 'clsx';
import { I18nInfo } from '@/user/models';
import { LineTabs } from '@/user/components/common';
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EduTab',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const t = new I18nInfo('eduCenter');
        const styles = {
            section: clsx('w-full', 'desktop:min-w-1400 desktop:px-0'),
        };
        const tabItems = ref([
            {
                id: 'tab1',
                text: t.translate('attend.title'),
                route: 'AttendList',
                routeGroup: ['AttendList', 'AttendDetail', 'AttendRegister'],
                disabled: false,
                isActive: false,
            },
            {
                id: 'tab2',
                text: t.translate('certification.testDateTitle'),
                route: 'CertificationExamDate',
                routeGroup: ['CertificationExamDate'],
                disabled: false,
                isActive: false,
            },
            {
                id: 'tab3',
                text: t.translate('certification.title'),
                route: 'CertificationInstruction',
                routeGroup: ['CertificationInstruction'],
                disabled: false,
                isActive: false,
            },
            {
                id: 'tab4',
                text: t.translate('certification.searchTitle'),
                route: 'Verify',
                routeGroup: ['Verify'],
                disabled: false,
                isActive: false,
            },
        ]);
        const setActiveTabFromCurrentRoute = () => {
            const currentRouteName = route.name;
            if (typeof currentRouteName !== 'string')
                return;
            const activeTab = tabItems.value.find((tab) => tab.routeGroup?.includes(currentRouteName) || tab.route === currentRouteName);
            if (activeTab) {
                tabItems.value.forEach((item) => {
                    item.isActive = item.id === activeTab.id;
                });
            }
        };
        onMounted(() => {
            setActiveTabFromCurrentRoute();
        });
        const handleTabClick = (tab) => {
            router.push({ name: tab.route || 'AttendList' });
            tabItems.value.forEach((item) => {
                item.isActive = item.id === tab.id;
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(styles.section)
            }, [
                _createVNode(_unref(LineTabs), {
                    class: "!text-m-title-2",
                    tabs: tabItems.value,
                    onTabClick: handleTabClick
                }, null, 8, ["tabs"])
            ], 2));
        };
    }
});
